<template>
  <div class="page-wrapper">
    <!-- 头部导航 -->
    <header class="header">
      <div class="header-content">
        <h1 class="brand">
          <span class="brand-icon">🎨</span>
          Remove BG
        </h1>
        <button @click="contactUs" class="contact-btn">
          <span class="btn-icon">✉️</span>
          Contact Us
        </button>
      </div>
    </header>

    <!-- Hero 区域 -->
    <section class="hero-section">
      <div class="hero-content">
        <div class="hero-badge">✨ AI-Powered Technology</div>
        <h2 class="hero-title">Altering the Image<br>Lights Up Creativity</h2>
        <p class="hero-subtitle">Transform your photos instantly with our professional background removal tool</p>
      </div>
    </section>

    <!-- 特色展示区 -->
    <section class="showcase-section">
      <div class="container">
        <div class="section-header">
          <h3 class="section-title">See The Magic ✨</h3>
          <p class="section-desc">Professional results in seconds</p>
        </div>
        <div class="showcase-card">
          <img src="/img/英语-1.png" alt="Featured showcase" />
          <div class="showcase-overlay">
            <div class="overlay-content">
              <h4>Perfect Edge Detection</h4>
              <p>Our AI accurately identifies and removes backgrounds while preserving fine details</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 功能展示网格 -->
    <section class="features-section">
      <div class="container">
        <div class="section-header">
          <h3 class="section-title">Powerful Features 🚀</h3>
          <p class="section-desc">Everything you need for perfect images</p>
        </div>
        <div class="features-grid">
          <div class="feature-card" v-for="(feature, index) in features" :key="index">
            <div class="feature-image">
              <img :src="feature.image" :alt="feature.title" />
              <div class="feature-badge">{{ feature.badge }}</div>
            </div>
            <div class="feature-content">
              <h4 class="feature-title">{{ feature.title }}</h4>
              <p class="feature-desc">{{ feature.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA区域 -->
    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h3 class="cta-title">Ready to Remove Backgrounds?</h3>
          <p class="cta-subtitle">Join millions of users creating stunning images</p>
          <button @click="contactUs" class="cta-button">Get Started Now</button>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-brand">
          <span class="footer-icon">🎨</span>
          <span>Remove BG</span>
        </div>
        <div class="footer-links">
          <router-link to="/remove_bg_privacy" class="footer-link">Privacy Policy</router-link>
          <span class="separator">•</span>
          <router-link to="/remove_bg_terms" class="footer-link">Terms of Service</router-link>
        </div>
        <p class="copyright">© 2023 videotomusic.com - All rights reserved</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
const features = [
  {
    image: '/img/英语-4.png',
    badge: 'Fast',
    title: 'Instant Processing',
    desc: 'Remove backgrounds in seconds with our lightning-fast AI technology'
  },
  {
    image: '/img/英语-5.png',
    badge: 'Precise',
    title: 'Perfect Edges',
    desc: 'Advanced edge detection ensures clean and natural-looking results'
  },
  {
    image: '/img/英语-3.png',
    badge: 'Easy',
    title: 'One-Click Solution',
    desc: 'No complex tools needed - just upload and download your result'
  },
  {
    image: '/img/英语-2.png',
    badge: 'Batch',
    title: 'Bulk Processing',
    desc: 'Process multiple images at once to save time and effort'
  },
  {
    image: '/img/英语-6.png',
    badge: 'Quality',
    title: 'HD Output',
    desc: 'Maintain original image quality with high-resolution exports'
  },
  {
    image: '/img/英语-7.png',
    badge: 'Free',
    title: 'No Watermarks',
    desc: 'Download your images without any watermarks or restrictions'
  }
]

const contactUs = () => {
  window.open("mailto:yikenyonggang@gmail.com")
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-wrapper {
  min-height: 100vh;
  background: #ffffff;
}

/* 头部样式 */
.header {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  padding: 18px 0;
  box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  color: white;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon {
  font-size: 28px;
}

.contact-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.8);
  color: white;
  padding: 12px 28px;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-icon {
  font-size: 16px;
}

.contact-btn:hover {
  background: white;
  color: #6366f1;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
}

/* Hero 区域 */
.hero-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.hero-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.hero-badge {
  display: inline-block;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.3);
}

.hero-title {
  font-size: 56px;
  font-weight: 900;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
  line-height: 1.2;
  letter-spacing: -1px;
}

.hero-subtitle {
  font-size: 20px;
  color: #64748b;
  font-weight: 400;
  line-height: 1.6;
}

/* 容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

/* 区块标题 */
.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 42px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
}

.section-desc {
  font-size: 18px;
  color: #64748b;
}

/* 特色展示区 */
.showcase-section {
  padding: 80px 20px;
  background: white;
}

.showcase-card {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  max-width: 900px;
  margin: 0 auto;
}

.showcase-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);
}

.showcase-card img {
  width: 100%;
  height: auto;
  display: block;
}

.showcase-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
  padding: 40px;
  transform: translateY(100%);
  transition: transform 0.4s ease;
}

.showcase-card:hover .showcase-overlay {
  transform: translateY(0);
}

.overlay-content h4 {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
}

.overlay-content p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  line-height: 1.6;
}

/* 功能网格 */
.features-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-top: 20px;
}

.feature-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid rgba(99, 102, 241, 0.1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(99, 102, 241, 0.2);
}

.feature-image {
  position: relative;
  overflow: hidden;
  height: 250px;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.feature-card:hover .feature-image img {
  transform: scale(1.1);
}

.feature-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.feature-content {
  padding: 25px;
}

.feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
}

/* CTA 区域 */
.cta-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.cta-content {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-title {
  font-size: 48px;
  font-weight: 900;
  color: white;
  margin-bottom: 20px;
  letter-spacing: -1px;
}

.cta-subtitle {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
}

.cta-button {
  background: white;
  color: #6366f1;
  border: none;
  padding: 18px 45px;
  border-radius: 35px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

/* 底部 */
.footer {
  background: #1e293b;
  padding: 50px 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.footer-icon {
  font-size: 24px;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-link {
  color: #cbd5e1;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
  font-weight: 500;
}

.footer-link:hover {
  color: #a78bfa;
}

.separator {
  color: #475569;
}

.copyright {
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .brand {
    font-size: 20px;
  }

  .brand-icon {
    font-size: 22px;
  }

  .contact-btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .hero-section {
    padding: 60px 20px;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .section-title {
    font-size: 32px;
  }

  .section-desc {
    font-size: 16px;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .cta-title {
    font-size: 32px;
  }

  .cta-subtitle {
    font-size: 16px;
  }

  .showcase-section,
  .features-section {
    padding: 60px 20px;
  }
}

@media screen and (max-width: 480px) {
  .header-content {
    padding: 0 20px;
  }

  .brand {
    font-size: 18px;
  }

  .contact-btn {
    padding: 8px 16px;
    font-size: 13px;
  }

  .btn-icon {
    display: none;
  }

  .hero-badge {
    font-size: 12px;
    padding: 6px 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 15px;
  }

  .section-title {
    font-size: 28px;
  }

  .showcase-overlay {
    padding: 25px;
  }

  .overlay-content h4 {
    font-size: 20px;
  }

  .overlay-content p {
    font-size: 14px;
  }

  .feature-image {
    height: 200px;
  }

  .feature-content {
    padding: 20px;
  }

  .cta-section {
    padding: 60px 20px;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-button {
    padding: 15px 35px;
    font-size: 16px;
  }

  .footer {
    padding: 40px 20px;
  }

  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}

/* 平滑滚动和动画 */
html {
  scroll-behavior: smooth;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-content > * {
  animation: fadeInUp 0.6s ease-out backwards;
}

.hero-badge {
  animation-delay: 0.1s;
}

.hero-title {
  animation-delay: 0.2s;
}

.hero-subtitle {
  animation-delay: 0.3s;
}
</style>





